export enum EntityEnum {
    dummyEntity = 'dummyEntity',
    oub = 'oub',
    inb = 'inb',
    toEV = 'toEV',
    fromEV = 'fromEV',
    soc = 'soc',
    hlgt = 'hlgt',
    hlt = 'hlt',
    pt = 'pt',
    llt = 'llt',
    mah = 'mah',
    mahvalidation = 'mahvalidation',
    sponsor = 'sponsor',
    sponsorvalidation = 'sponsorvalidation',
    atccode = 'atccode',
    source = 'source',
    pharmaceuticalForm = 'pharmaceuticalForm',
    roa = "roa",
    mfl = "mfl",
    attachment = 'attachment',
    approvedSubstance = 'approvedSubstance',
    developmentSubstance = 'developmentSubstance',
    authorisedProduct = 'authorisedProduct',
    authorisedProductValidVersion = 'authorisedProductValidVersion',
    authorisedProductLastVersion = 'authorisedProductLastVersion',
    authorisedProductOwned = 'authorisedProductOwned',
    authorisedProductFollowUp = 'authorisedProductFollowUP',
    authorisedProductValidation = 'authorisedProductValidation',
    developmentProductValidation = 'developmentProductValidation',
    developmentProduct = 'developmentProduct',
    developmentProductValidVersion = 'developmentProductValidVersion',
    developmentProductLastVersion = 'developmentProductLastVersion',
    developmentProductOwned = 'developmentProductOwned',
    medicinalProductType = 'mpt',
    presentationName = 'presentationName',
    scientificName = 'scientificName',
    abstractPharmaceuticalProduct = "abstractPharmaceuticalProduct",
    abstractPharmaceuticalProductsStrength = "abstractPharmaceuticalProductsStrength",
    abstractPharmaceuticalProductsFormulation = "abstractPharmaceuticalProductsFormulation",
    abstractPharmaceuticalProductSYM = "abstractPharmaceuticalProductSYM",
    abstractStrength = "abstractStrength",
    abstractStrengths = "abstractStrengths",
    abstractFormulation = "abstractFormulation",
    abstractFormulations = "abstractFormulations",
    abstractStrengthComposition = "abstractStrengthComposition",
    abstractFormulationComposition = "abstractFormulationComposition",
    abstractCompositions = "abstractCompositions", 
    abstractCompositionsSearch = "abstractCompositionsSearch",
    ownedEVMPDEntities = "ownerEVMPDEntities",
    ownedByEVMPDEntities = "ownerByEVMPDEntities",
    substancesNames = "substanceNames",
    approvedSubstanceNames = "approvedSubstanceNames",
    developmentSubstanceNames = "developmentSubstanceNames",
    xevprmMessage = "xevprmMessage",
    authorisedProductHist = 'authorisedProductHist',
    developmentProductHist = 'developmentProductHist',
    approvedSubstanceHist = 'approvedSubstanceHist',
    developmentSubstanceHist = 'developmentSubstanceHist',
    sourceHist = 'sourceHist',
    mahHist = 'mahHist',
    sponsorHist = 'sponsorHist',
    atccodeHist = 'atccodeHist',
    roaHist = "roaHist",
    pharmaceuticalFormHist = 'pharmaceuticalFormHist',
    mflHist = "mflHist",
    attachmentHist = 'attachmentHist',
    operationResult = 'operationResult',
    allOperationResult = 'allOperationResult',
}